import { gql } from '@apollo/client';

// Same position shape as GET_POSITIONS list view so PositionList/PositionRow work unchanged
export const GET_FILTERED_POSITIONS = gql`
  query GetFilteredPositions($filter: PositionFilterInput!) {
    filteredPositions(filter: $filter) {
      positions {
        id
        token {
          id
          name
          ticker
          isDelisted
          coingeckoId
          coingeckoSlug
          chartSymbol
          riskScore {
            score
          }
          group {
            id
            name
            description
          }
          location {
            id
            name
            description
          }
          marketData {
            id
            currentPrice
            priceChange1h
            priceChange24h
            priceChange7d
            priceChange30d
            priceChange1y
            volume24h
            marketCap
            fullyDilutedValuation
            marketCapFdvRatio
            marketCapCategory
            timestamp
          }
        }
        holdingsAmount
        holdingsValue
        averageNetCost
        averageBuyPrice
        investedCost
        current {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        unrealized {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        planned {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        plannedConservative {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        total {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        totalConservative {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        exitStrategy {
          levels {
            id
            amount
            price
            status
            warning
          }
          sellAmount
          proceeds
          cost
          templateId
          templateName
          isModified
          templateOutOfSync
          params {
            targetMultiple
            baseSource
            exitLevelsCount
            exitLevelsSpread
            takeInitialsEnabled
            takeInitialsMultiple
            hodlEnabled
            hodlPercentage
            advancedDistributionEnabled
            distributionCurve
            distributionFocus
            distributionIntensity
          }
        }
        strategyStatus {
          status
          tooltip
          exitStatus
          exitTooltip
          invalidationStatus
          invalidationTooltip
        }
        invalidationLevel {
          id
          templateId
          templateName
        }
        tags {
          id
          name
          slug
          color
        }
      }
      totalCount
      withExitStrategy
      withInvalidationStrategy
    }
  }
`;
